// SET_TEXT_FILTER
export const setTextFilter = (text = '') => (
    {
        type: 'SET_TEXT_FILTER',
        text: text
    });

// SORT_BY_AMOUNT
export const sortByCategory = (category = '') => (
    {
        type: 'SORT_BY_CATEGORY',
        category: category

    });




// WEBPACK FOOTER //
// ./src/store/actions/filterAction.js